import { createSelector } from 'reselect';
import { EmptyObject } from 'resources/EmptyDefaults';
import VoicemailsApi from './VoicemailsApi';

const UNLISTENED_VOICEMAILS_COUNT_NAMESPACE = 'unlistenedVoicemailsCount';

export const getUnlistenedCount = createSelector(
  (state) => state[UNLISTENED_VOICEMAILS_COUNT_NAMESPACE],
  (unlistenedVoicemailsCount) => unlistenedVoicemailsCount || EmptyObject
);

export const fetchUnlistenedVoicemailsCount = {
  fetchingApiFunc: VoicemailsApi.unlistenedCount,
  selector: getUnlistenedCount,
  dataNamespace: UNLISTENED_VOICEMAILS_COUNT_NAMESPACE,
};
